import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { AbstractModalComponent } from "../abstract-modal/abstract-modal.component";
import { BsModalRef } from "ngx-bootstrap/modal";
import { WarningModalService } from "../../services/warning-modal/warning-modal.service";
import { ConstantsService } from "../../services/constants/constants.service";
import { PermissionsService } from 'src/app/services/permissions/permissions.service';

@Component({
  selector: 'app-org-logo-modal',
  templateUrl: './org-logo-modal.component.pug',
  styleUrls: ['./org-logo-modal.component.scss'],
  standalone: false
})
export class OrgLogoModalComponent extends AbstractModalComponent implements OnInit {

  @Input() logo!: string;
  @ViewChild('orgForm', { static: false }) orgForm: any;
  showValidationError = false;
  file: any = null;
  filename = '';
  avatar: any = '';
  default_logo = ConstantsService.DEFAULT_LOGO;
  photoRemoved = false;

  constructor(public _bsModalRef: BsModalRef, public modal: WarningModalService, public permissions: PermissionsService) {
    super(_bsModalRef, modal);
  }

  ngOnInit(): void {
    this.avatar = this.logo !== null ? this.logo : this.default_logo;
  }

  cancel() {
    this.canDeactivate().subscribe(response => {
      if (response) {
        this.markAsPristine();
        this._bsModalRef.hide();
      }
    });
  }

  save() {
    this.messages = [];
    this.showValidationError = true;
    if (!this.orgForm.valid) {
      return;
    }
    const formData = new FormData();
    if (this.file === null || this.file === '') {
      if (this.photoRemoved) {
        formData.append('logo', '');
      }
      this.event.emit(formData);
    } else {
      formData.append('file', this.file, this.filename);
      this.event.emit(formData);
    }
  }

  getForm() {
    return this.orgForm;
  }

  removePhoto() {
    this.modal.confirm($localize`Remove logo?`, $localize`Are you sure you want to delete this logo?`, false,
      $localize`Cancel`, $localize`Yes`, true).subscribe(response => {
        if (response) {
          this.file = null;
          this.avatar = this.default_logo;
          this.photoRemoved = true;
        }
      });
  }

  handleFileInput(event) {
    if (event.target.files && event.target.files.length) {
      const [file] = event.target.files;
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.imageUpdate({ 'file': file, 'avatar': reader.result as string, 'filename': file.name });
      };
    }
  }

  imageUpdate(event: any) {
    this.file = event['file'];
    this.avatar = event['avatar'];
    this.filename = event['filename'];
    this.formDirty = true;
    this.photoRemoved = false;
  }
}
